import styled from "@emotion/styled";
import DeungiHeader from "@src/components/deungi/DeungiHeader";
import React from "react";
import ExpertMatchPricePackageListBox from "./ExpertMatchPricePackageListBox";
import { useSearchParams } from "react-router-dom";

const ExpertMatchPricePayment = () => {
    const [searchParams] = useSearchParams();
    const originalPrice = searchParams.get("originalPrice");
    if (!originalPrice) {
        return null;
    }
    return (
        <PaymentContainer>
            <DeungiHeader title="충전하기" />
            <div className="box">
                <ExpertMatchPricePackageListBox originalPrice={Number(originalPrice)} />
            </div>
        </PaymentContainer>
    );
};

export const PaymentContainer = styled.div`
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1dvh) * 100);
    animation: fadeIn 0.5s forwards;
    background-color: white;

    .box {
        position: absolute;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        overflow: auto;
        overscroll-behavior-y: none;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export default ExpertMatchPricePayment;
